const MB_SIZE = 1048576; // 1024 * 1024
const KB_SIZE = 1024;
const MAX_FILE_SIZE = MB_SIZE * 10; // 10Mb
export const MAX_FILE_SIZE_MB = MAX_FILE_SIZE / MB_SIZE;

export const isFileTooLarge = size => size >= MAX_FILE_SIZE

export const renderFileSize = size => {
  const isLargerThanMB = size > MB_SIZE;
  const calcSize = isLargerThanMB ? parseFloat(size / MB_SIZE).toFixed(2) : Math.round(size / KB_SIZE);
  const unit = isLargerThanMB ? 'Mb' : 'Kb';

  return calcSize + unit;
};



// WEBPACK FOOTER //
// ./src/components/FileInput/constants.js